import { render, staticRenderFns } from "./ConfirmAddress.vue?vue&type=template&id=2ed5db71&scoped=true&"
import script from "./ConfirmAddress.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddress.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAddress.vue?vue&type=style&index=0&id=2ed5db71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5db71",
  null
  
)

export default component.exports